export default __webpack_public_path__ + "static/media/condominium.d49dca28.svg";